import React from 'react'
import PropTypes from 'prop-types'

import S from './Content.styled'
import { useDropdownContext } from '../DropdownContext'

const SectionTitle = ({ children }) => {
  const { themeColor } = useDropdownContext()

  return (
    <S.ContentSectionTitle
      as="legend"
      className="section-title"
      themeColor={themeColor}
    >
      {children}
    </S.ContentSectionTitle>
  )
}

SectionTitle.propTypes = {
  children: PropTypes.node.isRequired,
}

export default SectionTitle
